// Report-specific user-facing messages and constants
export const REPORT_MESSAGES = {
    TITLE: 'Data Quality Report',
    LOADING: 'Loading data quality report...',
    ERROR: {
        FETCH_FAILED: 'Failed to load data quality report',
        RETRY: 'Retry',
        SHOW_DETAILS: 'Show details',
    },
    EMPTY_STATE: {
        NO_PROBLEMS: 'No data quality issues found - your data meets quality thresholds.',
        NO_PRESCRIPTIONS: 'No recommendations generated - data quality is above configured thresholds.',
    },
    SECTIONS: {
        EXECUTIVE_SUMMARY: 'Executive Summary',
        HEALTH_SCORE: 'Health Score',
        PROBLEMS: 'Key Data Problems',
        PRESCRIPTIONS: 'Recommended Actions',
        TECHNICAL_OVERVIEW: 'Technical Overview',
        UTILITIES: 'Report Utilities',
    },
    FILTERS: {
        SEVERITY: 'Filter by severity',
        CATEGORY: 'Filter by category',
        SEARCH: 'Search problems...',
        CLEAR_ALL: 'Clear all filters',
        EXPAND_ALL: 'Expand all',
        COLLAPSE_ALL: 'Collapse all',
    },
    ACCESSIBILITY: {
        EXPAND_PROBLEM: 'Expand problem details',
        COLLAPSE_PROBLEM: 'Collapse problem details',
        HEALTH_DIMENSIONS_CAPTION: 'Health dimension scores',
        SEVERITY_LABEL: (severity: string) => `${severity} severity`,
        PROBLEMS_COUNT: (count: number) => `${count} problem${count === 1 ? '' : 's'} shown`,
        REPORT_UPDATED: 'Report updated',
        REFRESH_FAILED: 'Refresh failed - showing previous data',
    },
    ACTIONS: {
        REFRESH: 'Refresh report',
        BACK_TO_DATA_SOURCES: 'Back to Data Sources',
    },
} as const;

// Severity color mapping for consistent styling - Dark theme with red accents
export const SEVERITY_STYLES = {
    critical: 'bg-red-900 text-red-100 border border-red-700',
    high: 'bg-red-800 text-red-100 border border-red-600',
    medium: 'bg-red-700 text-red-100 border border-red-500',
    low: 'bg-gray-700 text-gray-100 border border-gray-500',
} as const;

// Feature flags
export const REPORT_FEATURE_FLAGS = {
    VIRTUALIZE_THRESHOLD: 150,
    ENABLE_STICKY_FILTERS: false,
    ENABLE_TECHNICAL_OVERVIEW: false,
    ENABLE_EXPORT: false,
} as const;